<template>
  <error500 />
</template>

<script>
import error500 from '~/components/ErrorPages/500.vue';

export default {
  name: 'AllErrors',

  components: {
    error500
  }
};
</script>
